import { marked } from 'marked';

// Utils
import cn from '@/utils/cn';

// Styles
import styles from './Markdown.module.css';

interface MarkdownProps {
  text: string;
  className?: string;
}

function Markdown({
  text,
  className = '',
}: MarkdownProps) {
  
  return (
    <div
      className={cn([
        className,
        styles.markdown
      ])}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{__html: marked(text)}}
    />
  );
}

export default Markdown;